
import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import highResDesktopImageWebp from './images/di-hero-desktop.webp';
import highResMobileImageWebp from './images/di-hero-mobile.webp';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='disability-insurance-hero'
      productName='Disability Insurance'
      headingText={<>Protect your <WidowBlock>biggest asset.</WidowBlock></>}
      descriptionText='Your ability to earn a living is likely the most important financial asset you have. Disability insurance can help protect your income in case the unexpected happens.'
      ctaPrimary={{
        linkUrl: '/find-a-financial-advisor/',
        buttonText: 'Get insurance',
        ariaLabel: 'Get insurance with a financial professional.',
        children: '',
      }}
      backgroundImageAriaLabel='A young woman sitting at an outdoor table at a restaurant'
      backgroundImageDesktop={highResDesktopImageWebp.toString()}
      backgroundImageMobile={highResMobileImageWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageMobileLowRes={lowResImageMobile}
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );};
